import api from './client';

export interface CatalogoDigitalConfig {
  id: number;
  nomeCatalogo: string;
  empresaNome?: string;
  empresaTelefone?: string;
  empresaEmail?: string;
  empresaCodigo?: string;
  almoxarifadoCodigo?: string;
  marcasFiltro?: string;
  gruposFiltro?: string;
  apenasComEstoque: boolean;
  apenasAtivo: boolean;
  apenasDisponivelVenda: boolean;
  apenasEnviaMobile: boolean;
  /** Inclui produtos sem estoque físico mas com NFe em trânsito (selo "Em viagem"). Default true. */
  exibirEmTransito: boolean;
  /** Exclui do sync produtos marcados no ERP como "não vende no atacado" (QTDMINATC >= limiteSemAtacado). Default false. */
  excluirSemAtacado: boolean;
  /** Limite usado por excluirSemAtacado. Precisa ser > 1 — em 0 ou 1 o filtro excluiria praticamente todo o catálogo. Default 5000. */
  limiteSemAtacado: number;
  /** Exige a quantidade mínima de atacado (por variação) no carrinho público. Card/painel mostram o mínimo e o campo nasce nele. Default false. */
  exigirMinAtacado: boolean;
  exibirWhatsapp: boolean;
  exibirNomeEmpresa: boolean;
  agruparPor: string;
  intervaloSyncMinutos: number;
  horarioSyncAgendado?: string;
  diasNovidade: number;
  syncAtivo: boolean;
  ultimaSincronizacao?: string;
  totalProdutosSync: number;
  catalogoAtivo: boolean;
  token: string;
}

export interface CatalogoDigitalStats {
  totalCache: number;
  comImagem: number;
  marcas: number;
  ultimaSincronizacao?: string;
  intervaloMinutos: number;
  syncAtivo: boolean;
  catalogoAtivo: boolean;
  token: string;
  // URL pública canônica (em prod aponta pra VPS, ex: https://www.fermap.../catalogo).
  // Backend resolve a partir de Catalogo:PublicUrl ou do origin do request.
  linkPublico: string;
}

class CatalogoDigitalApi {
  async obterConfig(): Promise<CatalogoDigitalConfig> {
    const r = await api.get<CatalogoDigitalConfig>('/catalogo/digital/config');
    return r.data;
  }

  async salvarConfig(config: Partial<CatalogoDigitalConfig>): Promise<void> {
    await api.put('/catalogo/digital/config', config);
  }

  async forcarSincronizacao(): Promise<void> {
    // Sync inline pode levar até ~1min (Firebird + imagens). Sobe timeout
    // pra 3min como folga, evita o navegador cancelar request longa.
    await api.post('/catalogo/digital/sincronizar', null, { timeout: 180_000 });
  }

  async obterStats(): Promise<CatalogoDigitalStats> {
    const r = await api.get<CatalogoDigitalStats>('/catalogo/digital/stats');
    return r.data;
  }

  /**
   * @deprecated A URL pública agora vem de `stats.linkPublico` (resolvida pelo backend
   * a partir de Catalogo:PublicUrl em prod). Mantido só pra compat de chamadores antigos
   * que ainda passam token — retorna a URL nova ignorando o token.
   */
  getLinkPublico(_token?: string): string {
    return `${window.location.origin}/catalogo`;
  }
}

export const catalogoDigitalApi = new CatalogoDigitalApi();
